<p-toast />

<p-toast key="has-actions">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="flex flex-col gap-3 w-full">
      <section class="flex flex-col p-4 gap-4 w-full">
        <div class="flex items-center gap-5">
          <span class="p-toast-summary">{{ message.summary }}</span>
        </div>
        <ng-container *ngIf="message?.data?.actions?.length as len">
          <div class="flex gap-4 justify-end">
            <div class="flex flex-wrap gap-2 justify-end mt-2">
              <p-button
                *ngFor="let action of message.data.actions"
                [label]="action.label"
                [icon]="action.icon"
                [severity]="action.severity ?? 'primary'"
                [outlined]="action.outlined ?? false"
                [size]="action.size ?? 'small'"
                (onClick)="action.onClick(message); closeFn($event)"
              />
            </div>
          </div>
        </ng-container>
      </section>
    </div>
  </ng-template>
</p-toast>
